<template>
  <div
    ref="div"
    :class="{
      'file-loader': true,
      highlight: isPageOver || isInputOver,
      active: isInputOver,
    }"
    @drop="handleDrop"
    @click="openFileSaver"
  >
    <div class="container">
      <span v-if="isPageOver" v-t="'wizard.userAvatar.drop'" />
      <div v-else-if="file" class="file">
        <img class="uploaded-img" :src="fileURL" />
        <div class="uploaded-text">
          <span class="uploaded" v-t="'wizard.userAvatar.success'" />
          <span class="remove" @click="handleRemoveFile">×</span>
        </div>
      </div>
      <span v-else-if="error" class="error">{{ error }}</span>
      <span
        v-else-if="progress"
        v-t="{ path: 'wizard.userAvatar.progress', args: { progress: this.uploaded } }"
      />
      <span v-else>
        <span class="choose-desktop" v-t="'wizard.userAvatar.choose'" />
        <span class="choose-mobile" v-t="'wizard.userAvatar.chooseMobile'" />
      </span>
      <input ref="input" v-bind="$attrs" type="file" :accept="accept" @change="onFileChange" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { captureException } from '@sentry/browser';

export default {
  inheritAttrs: false,
  props: {
    value: {
      type: String,
    },
    accept: {
      type: String,
      default: 'image/png, image/jpeg',
    },
  },
  data() {
    return {
      error: null,
      file: false,
      progress: false,
      uploaded: 0,
      isInputOver: false,
      isPageOver: false,
      leaveTimer: null,
      s3PresignedPutUrl: null,
      s3PresginedUploadId: null,
    };
  },
  methods: {
    handleDrop(event) {
      this.onFileChange(event);
      this.isInputOver = false;
      this.isPageOver = false;
    },
    handleRemoveFile(event) {
      event.preventDefault();
      event.stopPropagation();
      this.removeFile();
    },
    openFileSaver() {
      this.$refs.input.click();
    },
    onFileChange(event) {
      event.preventDefault();
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.uploadFile(files[0]);
    },
    removeFile() {
      this.progress = false;
      this.file = false;
      this.$emit('load', null);
      this.$refs.input.value = '';
    },
    async uploadFile(file) {
      this.file = false;
      this.progress = true;

      try {
        const [s3PresignedPutUrl, uploadId] = await this.getS3PresignedPutUrl();
        await this.uploadFileByUrl(file, s3PresignedPutUrl);
        this.file = file;
        this.progress = false;
        this.$emit('load', uploadId);
      } catch (err) {
        captureException(err);
        this.error = this.$t('wizard.userAvatar.errors.default');
        this.removeFile();
      }
    },
    // TODO: extract to service
    async getS3PresignedPutUrl() {
      if (this.s3PresignedPutUrl !== null) {
        return [this.s3PresignedPutUrl, this.s3PresginedUploadId];
      }

      const { errors, data } = await fetch('/api/quiz/upload-presigned-url').then(response =>
        response.json(),
      );

      if (errors.length > 0) {
        throw new Error(errors[0].message);
      }

      this.s3PresignedPutUrl = data.presignedPutUrl;
      this.s3PresginedUploadId = data.uploadId;

      if (this.s3PresignedPutUrl !== null) {
        return [this.s3PresignedPutUrl, this.s3PresginedUploadId];
      }
    },
    async uploadFileByUrl(file, presignedPutUrl) {
      await axios.put(presignedPutUrl, file, {
        onUploadProgress: ({ loaded, total }) => {
          this.uploaded = ((loaded / total) * 100).toFixed();
        },
      });
      this.uploaded = 0;
    },
    handlePageOver(event) {
      event.preventDefault();
      this.isPageOver = true;
      this.isInputOver = this.$refs.div.contains(event.target);

      clearTimeout(this.leaveTimer);
      this.leaveTimer = setTimeout(() => {
        this.isPageOver = false;
      }, 100);
    },
  },
  computed: {
    fileURL() {
      return this.file ? URL.createObjectURL(this.file) : '';
    },
  },
  mounted() {
    document.addEventListener('dragover', this.handlePageOver);
  },
  beforeDestroy() {
    clearTimeout(this.leaveTimer);
    document.removeEventListener('dragover', this.handlePageOver);
  },
};
</script>

<style scoped src="./inputTypeFile.css"></style>
